import { render, staticRenderFns } from "./Dokumen.vue?vue&type=template&id=df8ccf8e"
import script from "./Dokumen.vue?vue&type=script&lang=js"
export * from "./Dokumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports